/**
 * @fileoverview Provides a Deferred class that allows creating and resolving/rejecting promises
 * from outside the Promise constructor.
 *
 * @example
 * const deferred = new Deferred<string>();
 *
 * // The promise can be accessed immediately
 * deferred.promise.then(value => console.log(value));
 *
 * // Later, resolve or reject the promise
 * deferred.resolve('Hello World'); // Logs: Hello World
 *
 * @example
 * // Error handling
 * const deferred = new Deferred<number>();
 * deferred.promise.catch(err => console.error(err));
 * deferred.reject(new Error('Something went wrong'));
 */



export class Deferred<T> {
    public readonly promise: Promise<T>
    private resolveFn!: (value: T | PromiseLike<T>) => void
    private rejectFn!: (reason?: unknown) => void

    public constructor() {
        this.promise = new Promise<T>((resolve, reject) => {
            this.resolveFn = resolve
            this.rejectFn = reject
        })
    }

    public reject(reason?: unknown): void {
        this.rejectFn(reason)
    }

    public resolve(param: T): void {
        this.resolveFn(param)
    }
}
